/* 
eslint no-restricted-globals: "off",
eslint-disable-next-line : "off",
no-unused-expressions: "off",
no-sequences: "off", default-case: "off"
*/
import $ from "jquery";
import "../tangible.css";
let Tangible;

!(function(t) {
  function e(i) {
    if (n[i]) return n[i].exports;
    var a = (n[i] = { i: i, l: !1, exports: {} });
    return t[i].call(a.exports, a, a.exports, e), (a.l = !0), a.exports;
  }
  var n = {};
  (e.m = t),
    (e.c = n),
    (e.i = function(t) {
      return t;
    }),
    (e.d = function(t, n, i) {
      e.o(t, n) ||
        Object.defineProperty(t, n, {
          configurable: !1,
          enumerable: !0,
          get: i
        });
    }),
    (e.n = function(t) {
      var n =
        t && t.__esModule
          ? function() {
              return t.default;
            }
          : function() {
              return t;
            };
      return e.d(n, "a", n), n;
    }),
    (e.o = function(t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (e.p = ""),
    e((e.s = 16));
})([
  function(t, e, n) {
    function i(t, e) {
      if (!(t instanceof e))
        throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", { value: !0 });
    var a = (function() {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, i.key, i);
          }
        }
        return function(e, n, i) {
          return n && t(e.prototype, n), i && t(e, i), e;
        };
      })(),
      s = (function() {
        function t() {
          i(this, t);
        }
        return (
          a(t, null, [
            {
              key: "get",
              value: function(t) {
                var e = { stroke: "#6472EE" };
                return (
                  (e.x = t.x || 0),
                  (e.y = t.y || 0),
                  (e.angle = t.angle || 0),
                  ("rectangle" !== t.type &&
                    "image" !== t.type &&
                    "text" !== t.type) ||
                    ((e.width = t.width || 0),
                    (e.height = t.height || 0),
                    (e.anchorX = t.anchorX || 0),
                    (e.anchorY = t.anchorY || 0)),
                  "circle" === t.type &&
                    ((e.width = 2 * t.radius || 0),
                    (e.height = 2 * t.radius || 0),
                    (e.anchorX = e.width / 2),
                    (e.anchorY = e.height / 2)),
                  "ellipse" === t.type &&
                    ((e.width = 2 * t.radiusX || 0),
                    (e.height = 2 * t.radiusY || 0),
                    (e.anchorX = e.width / 2),
                    (e.anchorY = e.height / 2)),
                  (e.centerX =
                    0 === t.centerX ? t.centerX : t.centerX || t.anchorX),
                  (e.centerY =
                    0 === t.centerY ? t.centerY : t.centerY || t.anchorY),
                  (e.nodes = {
                    topLeft: {
                      x: -e.anchorX,
                      y: -e.anchorY,
                      opposite: "bottomRight",
                      scale: "both"
                    },
                    topMiddle: {
                      x: -e.anchorX + e.width / 2,
                      y: -e.anchorY,
                      opposite: "bottomMiddle",
                      scale: "y"
                    },
                    topRight: {
                      x: -e.anchorX + e.width,
                      y: -e.anchorY,
                      opposite: "bottomLeft",
                      scale: "both"
                    },
                    middleLeft: {
                      x: -e.anchorX,
                      y: -e.anchorY + e.height / 2,
                      opposite: "middleRight",
                      scale: "x"
                    },
                    middleRight: {
                      x: -e.anchorX + e.width,
                      y: -e.anchorY + e.height / 2,
                      opposite: "middleLeft",
                      scale: "x"
                    },
                    bottomLeft: {
                      x: -e.anchorX,
                      y: -e.anchorY + e.height,
                      opposite: "topRight",
                      scale: "both"
                    },
                    bottomMiddle: {
                      x: -e.anchorX + e.width / 2,
                      y: -e.anchorY + e.height,
                      opposite: "topMiddle",
                      scale: "y"
                    },
                    bottomRight: {
                      x: -e.anchorX + e.width,
                      y: -e.anchorY + e.height,
                      opposite: "topLeft",
                      scale: "both"
                    },
                    rotate: { x: -e.anchorX + e.width / 2, y: -e.anchorY - 20 },
                    anchor: { x: 0, y: 0 }
                  }),
                  e
                );
              }
            }
          ]),
          t
        );
      })();
    e.default = s;
  },
  function(t, e, n) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    var i = {
      move: function(t, e, n) {
        return !t.length || n > t.length - 1 || n < 0
          ? e
          : (t.splice(n, 0, t.splice(e, 1)[0]), n);
      },
      parseHtml: function(t) {
        return new DOMParser().parseFromString(t, "text/html").body.firstChild;
      },
      offset: function() {
        for (
          var t = this, e = t.offsetLeft, n = t.offsetTop;
          (t = t.offsetParent);

        )
          (e += t.offsetLeft), (n += t.offsetTop);
        return { left: e, top: n };
      },
      isBrowser: function(t) {
        return navigator.userAgent.toLowerCase().indexOf(t.toLowerCase()) > -1;
      },
      transformCoordinates: function(t) {
        var e = Math.abs(t.angle - t.tangle);
        return t.toOriginal
          ? {
              x: t.x * Math.cos(e) - t.y * Math.sin(e) + t.tx,
              y: t.x * Math.sin(e) + t.y * Math.cos(e) + t.ty
            }
          : {
              x: (t.x - t.tx) * Math.cos(e) + (t.y - t.ty) * Math.sin(e),
              y: -(t.x - t.tx) * Math.sin(e) + (t.y - t.ty) * Math.cos(e)
            };
      }
    };
    e.default = i;
  },
  function(t, e, n) {
    function i(t, e) {
      if (!(t instanceof e))
        throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", { value: !0 });
    var a = function t(e) {
      i(this, t),
        (this.canvas = document.createElement("canvas")),
        (this.canvas.width = e.width),
        (this.canvas.height = e.height),
        (this.context = this.canvas.getContext("2d"));
    };
    e.default = a;
  },
  function(t, e, n) {
    function i(t) {
      return t && t.__esModule ? t : { default: t };
    }
    function a(t, e) {
      if (!(t instanceof e))
        throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", { value: !0 });
    var s = (function() {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, i.key, i);
          }
        }
        return function(e, n, i) {
          return n && t(e.prototype, n), i && t(e, i), e;
        };
      })(),
      o = n(8),
      c = i(o),
      r = n(11),
      h = i(r),
      l = n(4),
      u = i(l),
      f = n(12),
      d = i(f),
      v = n(14),
      g = i(v),
      y = n(1),
      p = i(y),
      x = (function() {
        function t(e) {
          a(this, t),
            (this.id = "canvas" + new Date().valueOf()),
            (this.interactDom =
              e.interactDom ||
              p.default.parseHtml(
                '<canvas style="z-index : 3; pointer-events : none"></canvas>'
              )),
            (this.interactContext = this.interactDom.getContext("2d")),
            (this.canvasDOM =
              e.canvasDOM ||
              p.default.parseHtml('<canvas style="z-index : 1"></canvas>')),
            (this.width = this.canvasDOM.width = this.interactDom.width =
              e.width),
            (this.height = this.canvasDOM.height = this.interactDom.height =
              e.height),
            (this.context = this.canvasDOM.getContext("2d")),
            (this.objects = []),
            (this.order = []),
            (this.path = e.path);
        }
        return (
          s(t, [
            {
              key: "draw",
              value: function(t) {
                switch (t.type) {
                  case "rectangle":
                    this.drawRectangle(t);
                    break;
                  case "circle":
                    this.drawCircle(t);
                    break;
                  case "ellipse":
                    this.drawEllipse(t);
                    break;
                  case "polygon":
                    this.drawPolygon(t);
                    break;
                  case "image":
                    this.drawImage(t);
                    break;
                  case "text":
                    this.drawText(t);
                }
              }
            },
            {
              key: "createGradient",
              value: function(t) {
                for (
                  var e = this.context.createRadialGradient(
                      t.circles[0].x,
                      t.circles[0].y,
                      t.circles[0].radius,
                      t.circles[1].x,
                      t.circles[1].y,
                      t.circles[1].radius
                    ),
                    n = 0,
                    i = t.stop.length - 1;
                  n <= i;
                  n++
                )
                  e.addColorStop(t.stop[n].position, t.stop[n].color);
                return e;
              }
            },
            {
              key: "createObject",
              value: function(t) {
                var e = this;
                return new Promise(function(n, i) {
                  switch (t.type) {
                    case "rectangle":
                      n(new u.default(t, { width: e.width, height: e.height }));
                      break;
                    case "circle":
                      n(new c.default(t));
                      break;
                    case "ellipse":
                      n(new h.default(t, { width: e.width, height: e.height }));
                      break;
                    case "image":
                      n(
                        new d.default(t, {
                          width: e.width,
                          height: e.height
                        }).load(t, e.path.img)
                      );
                      break;
                    case "text":
                      n(new g.default(t, { width: e.width, height: e.height }));
                  }
                }).then(function(t) {
                  return new Promise(function(n, i) {
                    n(e.objects.push(t));
                  });
                });
              }
            },
            {
              key: "drawRectangle",
              value: function(t) {
                this.context.save(),
                  "gradient" === t.fill.type &&
                    (this.context.fillStyle = this.createGradient(t.fill)),
                  "solid" === t.fill.type &&
                    (this.context.fillStyle = t.getFill()),
                  (this.context.strokeStyle = t.getStroke()),
                  this.context.translate(t.x, t.y),
                  null !== t.angle && this.context.rotate(t.angle),
                  null !== this.context.fillStyle &&
                    this.context.fillRect(
                      -t.anchorX,
                      -t.anchorY,
                      t.width,
                      t.height
                    ),
                  null !== t.stroke &&
                    this.context.strokeRect(
                      -t.anchorX,
                      -t.anchorY,
                      t.width,
                      t.height
                    ),
                  this.context.restore();
              }
            },
            {
              key: "drawCircle",
              value: function(t) {
                this.context.save(),
                  "solid" === t.fill.type &&
                    (this.context.fillStyle = t.getFill()),
                  (this.context.strokeStyle = t.getStroke()),
                  this.context.translate(t.x, t.y),
                  null !== t.angle && this.context.rotate(t.angle),
                  this.context.beginPath(),
                  this.context.arc(0, 0, t.radius, t.startAngle, t.endAngle),
                  null !== t.fill &&
                    null !== t.fill.color &&
                    this.context.fill(),
                  null !== t.stroke && this.context.stroke(),
                  this.context.restore();
              }
            },
            {
              key: "drawEllipse",
              value: function(t) {
                this.context.save(),
                  "solid" === t.fill.type &&
                    (this.context.fillStyle = t.getFill()),
                  (this.context.strokeStyle = t.getStroke()),
                  this.context.translate(t.x, t.y),
                  null !== t.angle && this.context.rotate(t.angle),
                  this.context.beginPath(),
                  this.context.ellipse(
                    0,
                    0,
                    t.radiusX,
                    t.radiusY,
                    0,
                    t.startAngle,
                    t.endAngle
                  ),
                  null !== t.fill &&
                    null !== t.fill.color &&
                    this.context.fill(),
                  null !== t.stroke && this.context.stroke(),
                  this.context.restore();
              }
            },
            { key: "drawPolygon", value: function(t) {} },
            {
              key: "drawImage",
              value: function(t) {
                t.loaded &&
                  (this.context.save(),
                  this.context.translate(t.x, t.y),
                  null !== t.angle && this.context.rotate(t.angle),
                  this.context.scale(t.scaleX, t.scaleY),
                  this.context.drawImage(
                    t.image,
                    -t.anchorX,
                    -t.anchorY,
                    t.width,
                    t.height
                  ),
                  this.context.restore());
              }
            },
            {
              key: "drawText",
              value: function(t) {
                this.context.save(),
                  this.context.translate(t.x, t.y),
                  null !== t.angle && this.context.rotate(t.angle),
                  this.context.scale(t.scaleX, t.scaleY),
                  (this.context.fillStyle = t.getFill()),
                  (this.context.strokeStyle = t.getStroke()),
                  (this.context.font = t.font),
                  (this.context.textAlign = t.textAlign),
                  (this.context.textBaseline = t.textBaseline),
                  (this.context.direction = t.direction),
                  null !== t.fill &&
                    null !== t.fill.color &&
                    this.context.fillText(t.text, 0, 0, t.width),
                  null !== t.stroke &&
                    this.context.strokeText(t.text, 0, 0, t.width),
                  this.context.restore();
              }
            },
            {
              key: "update",
              value: function() {
                for (var t = 0, e = this.order.length - 1; t <= e; t++)
                  this.objects[this.order[t]].update();
              }
            },
            {
              key: "clearCanvas",
              value: function(t) {
                this.context.clearRect(0, 0, this.width, this.height);
              }
            },
            {
              key: "render",
              value: function() {
                this.clearCanvas();
                for (var t = 0, e = this.objects.length - 1; t <= e; t++)
                  this.draw(this.objects[t]);
              }
            }
          ]),
          t
        );
      })();
    e.default = x;
  },
  function(t, e, n) {
    function i(t) {
      return t && t.__esModule ? t : { default: t };
    }
    function a(t, e) {
      if (!(t instanceof e))
        throw new TypeError("Cannot call a class as a function");
    }
    function s(t, e) {
      if (!t)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return !e || ("object" !== typeof e && "function" !== typeof e) ? t : e;
    }
    function o(t, e) {
      if ("function" !== typeof e && null !== e)
        throw new TypeError(
          "Super expression must either be null or a function, not " + typeof e
        );
      (t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      })),
        e &&
          (Object.setPrototypeOf
            ? Object.setPrototypeOf(t, e)
            : (t.__proto__ = e));
    }
    Object.defineProperty(e, "__esModule", { value: !0 });
    var c = (function() {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, i.key, i);
          }
        }
        return function(e, n, i) {
          return n && t(e.prototype, n), i && t(e, i), e;
        };
      })(),
      r = n(2),
      h = i(r),
      l = n(0),
      u = i(l),
      f = (function(t) {
        function e(t, n) {
          a(this, e);
          var i = s(
            this,
            (e.__proto__ || Object.getPrototypeOf(e)).call(this, n)
          );
          return (
            (i.id = "rect_" + new Date().valueOf()),
            (i.type = "rectangle"),
            (i.x = t.x || 0),
            (i.y = t.y || 0),
            (i.width = t.width || 0),
            (i.height = t.height || 0),
            (i.scaleX = t.scaleX || 1),
            (i.scaleY = t.scaleY || 1),
            (i.fill = t.fill || { type: "solid", color: null }),
            (i.stroke = null === t.stroke ? t.stroke : t.stroke || "#000000"),
            (i.anchorX = i.width / 2 || 0),
            (i.anchorY = i.height / 2 || 0),
            (i.angle = t.angle || 0),
            (i.tween = t.tween || null),
            (i.tweeing = !1),
            i
          );
        }
        return (
          o(e, t),
          c(e, [
            {
              key: "getImageData",
              value: function(t) {
                return (
                  this.context.clearRect(
                    0,
                    0,
                    this.canvas.width,
                    this.canvas.height
                  ),
                  this.context.save(),
                  this.context.translate(this.x, this.y),
                  null !== this.angle && this.context.rotate(this.angle),
                  null !== this.fill &&
                    this.context.fillRect(
                      -this.anchorX,
                      -this.anchorY,
                      this.width,
                      this.height
                    ),
                  null !== this.stroke &&
                    this.context.strokeRect(
                      -this.anchorX,
                      -this.anchorY,
                      this.width,
                      this.height
                    ),
                  this.context.restore(),
                  this.context.getImageData(t.x, t.y, 1, 1)
                );
              }
            },
            {
              key: "getX",
              value: function() {
                return this.x;
              }
            },
            {
              key: "getY",
              value: function() {
                return this.y;
              }
            },
            {
              key: "getWidth",
              value: function() {
                return this.width;
              }
            },
            {
              key: "getHeight",
              value: function() {
                return this.height;
              }
            },
            {
              key: "getFill",
              value: function() {
                return this.fill.color;
              }
            },
            {
              key: "getStroke",
              value: function() {
                return this.stroke;
              }
            },
            {
              key: "getAngle",
              value: function() {
                return (180 * this.angle) / Math.PI;
              }
            },
            {
              key: "getScaleX",
              value: function() {
                return this.scaleX;
              }
            },
            {
              key: "getScaleY",
              value: function() {
                return this.scaleY;
              }
            },
            {
              key: "setScaleX",
              value: function(t) {
                if (t > 0) {
                  var e = this.scaleX <= t ? 1 : -1;
                  (this.scaleX = t), (this.width += e * (t / 100) * this.width);
                }
              }
            },
            {
              key: "setScaleY",
              value: function(t) {
                if (t > 0) {
                  var e = this.scaleY <= t ? t : 1 / (this.scaleY * t);
                  (this.scaleY = t), (this.height = e);
                }
              }
            },
            {
              key: "setX",
              value: function(t) {
                this.x = t;
              }
            },
            {
              key: "setY",
              value: function(t) {
                this.y = t;
              }
            },
            {
              key: "setWidth",
              value: function(t) {
                (this.width = t), (this.anchorX = this.width / 2);
              }
            },
            {
              key: "setHeight",
              value: function(t) {
                (this.height = t), (this.anchorY = this.height / 2);
              }
            },
            {
              key: "setFill",
              value: function(t) {
                this.fill.color = t;
              }
            },
            {
              key: "setStroke",
              value: function(t) {
                this.stroke = t;
              }
            },
            {
              key: "setAngle",
              value: function(t) {
                this.angle = (t * Math.PI) / 180;
              }
            },
            {
              key: "getBBox",
              value: function() {
                return u.default.get(this);
              }
            }
          ]),
          e
        );
      })(h.default);
    e.default = f;
  },
  function(t, e, n) {
    function i(t) {
      return t && t.__esModule ? t : { default: t };
    }
    function a(t, e) {
      if (!(t instanceof e))
        throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", { value: !0 });
    var s = (function() {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, i.key, i);
          }
        }
        return function(e, n, i) {
          return n && t(e.prototype, n), i && t(e, i), e;
        };
      })(),
      o = n(3),
      c = i(o),
      r = n(6),
      h = i(r),
      l = n(7),
      u = i(l),
      f = n(1),
      d = i(f),
      v = n(10),
      g = i(v),
      y = n(13),
      p = i(y),
      x = (function() {
        function t(e) {
          a(this, t),
            (this.startTime = null),
            (this.currentScene = null),
            (this.ready = null),
            (this.loaded = []),
            e.data
              ? ((this.stage = e.data), (this.currentScene = 1))
              : ((this.stage = {
                  start: 1,
                  end: 1,
                  background: { objects: [] },
                  foreground: {
                    scene: {
                      1: {
                        meta: {
                          scene: 1,
                          animate: !1,
                          duration: 1e3,
                          next: null
                        },
                        objects: [],
                        audio: []
                      }
                    }
                  }
                }),
                (this.currentScene = 1)),
            (this.path = e.path),
            (this.height = e.height),
            (this.width = e.width),
            (this.target = e.target),
            (this.scenes = {}),
            (this.bgCanvas = this.stage.background
              ? d.default.parseHtml(
                  '<canvas class="canvas-background" tabindex="1" style="z-index : 1"></canvas>'
                )
              : null),
            (this.fgCanvas = this.stage.foreground
              ? d.default.parseHtml(
                  '<canvas class="canvas-foreground" tabindex="1" style="z-index : 2"></canvas>'
                )
              : null),
            (this.interactCanvas = d.default.parseHtml(
              '<canvas class="canvas-interactive" tabindex="1" style="z-index : 3; pointer-events : none"></canvas>'
            )),
            this.init();
        }
        return (
          s(t, [
            {
              key: "init",
              value: function() {
                var t = this;
                if (
                  ($(this.target).append(this.interactCanvas), this.bgCanvas)
                ) {
                  $(this.target).append(this.bgCanvas);
                  var e = new c.default({
                    interactDom: this.interactCanvas,
                    canvasDOM: this.bgCanvas,
                    height: this.height,
                    width: this.width,
                    path: this.path
                  });
                  this.stage.background.objects.forEach(function(n) {
                    t.loaded.push(e.createObject(n));
                  }),
                    (this.background = { canvas: e });
                }
                if (this.fgCanvas) {
                  $(this.target).append(this.fgCanvas),
                    (this.playBtn = d.default.parseHtml(
                      '\n\t\t\t\t\t\t<div class="play absolute" style="margin-top : ' +
                        (this.height + 10) +
                        'px">\n\t\t\t\t\t        <div class="icon-play"></div>\n\t\t\t\t\t    </div>\n\t\t\t\t'
                    )),
                    (this.seekBar = d.default.parseHtml(
                      '<div class="seekbar absolute" style="margin-top : ' +
                        (this.height + 10) +
                        'px;">\n\t\t\t\t              <input type="range" min="' +
                        this.stage.start +
                        '" max="' +
                        this.stage.end +
                        '" value="' +
                        this.currentScene +
                        '" step="1" style="width:' +
                        this.width +
                        '"/>\n\t\t\t\t        </div>'
                    )),
                    (this.sceneUL = d.default.parseHtml(
                      '<ul style="\n\t\t\t\t\t\tposition : absolute ;\n\t\t\t\t\t\ttop : ' +
                        (d.default.offset.apply(this.fgCanvas).top +
                          this.height) +
                        "px ;\n\t\t\t\t\t\tleft : 0px;\n\t\t\t\t\t\twidth : " +
                        this.width +
                        '"\n\t\t\t\t\t class="sceneList">\n\t\t\t\t</ul>'
                    )),
                    $(this.target).append(this.playBtn),
                    $(this.target).append(this.seekBar),
                    this.playBtn.addEventListener("click", function(event) {
                      event.stopPropagation(),
                        t.playing
                          ? (t.beforeSceneChange(),
                            (t.currentScene = t.currentScene),
                            t.afterSceneChange(),
                            t.btnPause())
                          : (t.scenes[t.currentScene].toolbox.updateCanvas({
                              bbox: !1,
                              canvas: !1
                            }),
                            t.playScene(t.currentScene),
                            t.btnPlay());
                    }),
                    $(this.seekBar)
                      .find("input[type=range]")
                      .on("input", function(e) {
                        e.stopPropagation(),
                          t.beforeSceneChange(),
                          t.btnPause(),
                          (t.currentScene = e.target.value),
                          t.afterSceneChange();
                      }),
                    this.sceneUL.appendChild(
                      d.default.parseHtml(
                        '\n\t\t\t\t<li class="scenes">\n\t\t\t\t\t<button class="btn btn-default btn-small">\n\t\t\t\t\t\t<i class="glyphicon glyphicon-play"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</li>'
                      )
                    ),
                    this.sceneUL.children[0].firstElementChild.addEventListener(
                      "click",
                      function() {
                        t.playScene(t.currentScene);
                      }
                    ),
                    this.sceneUL.appendChild(
                      d.default.parseHtml(
                        '\n\t\t\t\t<li class="scenes">\n\t\t\t\t\t<button class="btn btn-default btn-small">\n\t\t\t\t\t\t<i class="glyphicon glyphicon-plus"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</li>'
                      )
                    ),
                    this.sceneUL.children[1].firstElementChild.addEventListener(
                      "click",
                      function() {
                        t.addScene();
                      }
                    );
                  for (var n = this.stage.start; n; )
                    this.addScene(this.stage.foreground.scene[n]),
                      (n = this.stage.foreground.scene[n].meta.next);
                  Promise.all(this.loaded).then(function() {
                    t.ready ? t.ready() : t.afterSceneChange();
                  });
                }
              }
            },
            {
              key: "btnPlay",
              value: function() {
                $(this.playBtn)
                  .find("div")
                  .removeClass("icon-play"),
                  $(this.playBtn)
                    .find("div")
                    .addClass("icon-pause");
              }
            },
            {
              key: "btnPause",
              value: function() {
                $(this.playBtn)
                  .find("div")
                  .addClass("icon-play"),
                  $(this.playBtn)
                    .find("div")
                    .removeClass("icon-pause");
              }
            },
            {
              key: "addScene",
              value: function(t) {
                var e,
                  n = this;
                if (t) {
                  this.scenes[t.meta.scene] = {};
                  var i = new c.default({
                    interactDom: this.interactCanvas,
                    canvasDOM: this.fgCanvas,
                    height: this.height,
                    width: this.width,
                    path: this.path
                  });
                  this.stage.foreground.scene[t.meta.scene].objects.forEach(
                    function(t) {
                      n.loaded.push(i.createObject(t));
                    }
                  ),
                    this.stage.foreground.scene[t.meta.scene].audio.length &&
                      this.stage.foreground.scene[t.meta.scene].audio.forEach(
                        function(e) {
                          (n.scenes[t.meta.scene].audio =
                            n.scenes[t.meta.scene].audio || []),
                            n.scenes[t.meta.scene].audio.push(
                              new h.default({
                                path: n.path.audio,
                                url: e.url,
                                duration: e.duration || null
                              })
                            );
                        }
                      ),
                    (this.scenes[t.meta.scene].canvas = i),
                    (this.scenes[t.meta.scene].meta = {
                      scene: this.stage.foreground.scene[t.meta.scene].meta
                        .scene,
                      animate:
                        this.stage.foreground.scene[t.meta.scene].meta
                          .animate || !1,
                      duration:
                        this.stage.foreground.scene[t.meta.scene].meta
                          .duration || 1e3,
                      next:
                        this.stage.foreground.scene[t.meta.scene].meta.next ||
                        null
                    }),
                    (e =
                      '<li class="scenes" scene="' +
                      t.meta.scene +
                      '">' +
                      t.meta.scene +
                      "</li>");
                } else {
                  var a = 1 + ~~this.stage.end,
                    s = new c.default({
                      interactDom: this.interactCanvas,
                      canvasDOM: this.fgCanvas,
                      height: this.height,
                      width: this.width,
                      path: this.path
                    });
                  (this.scenes[a] = {
                    canvas: s,
                    meta: { animate: !1, scene: a, next: null, duration: 1e3 },
                    audio: []
                  }),
                    this.beforeSceneChange(),
                    (this.currentScene = a),
                    (this.scenes[this.stage.end].meta.next = a),
                    (this.stage.end = a),
                    (e = '<li class="scenes" scene="' + a + '">' + a + "</li>"),
                    this.afterSceneChange();
                }
                var o = d.default.parseHtml(e);
                this.sceneUL.appendChild(o),
                  o.addEventListener("click", function(t) {
                    t.stopPropagation(),
                      n.beforeSceneChange(),
                      (n.currentScene = o.getAttribute("scene")),
                      n.afterSceneChange();
                  });
              }
            },
            {
              key: "save",
              value: function() {
                return g.default.export(this);
              }
            },
            {
              key: "beforeSceneChange",
              value: function() {
                this.scenes[this.currentScene].toolbox &&
                  (this.scenes[this.currentScene].toolbox.destroy(),
                  delete this.scenes[this.currentScene].toolbox),
                  this.scenes[this.currentScene].audio &&
                    this.scenes[this.currentScene].audio.forEach(function(t) {
                      t.stop();
                    });
              }
            },
            {
              key: "destroy",
              value: function() {
                this.playing = !1;
                for (var t in this.scenes)
                  this.scenes[t].toolbox &&
                    (this.scenes[t].toolbox.destroy(),
                    delete this.scenes[t].toolbox),
                    this.scenes[t].audio &&
                      this.scenes[t].audio.forEach(function(t) {
                        t.stop();
                      });
              }
            },
            {
              key: "afterSceneChange",
              value: function() {
                (this.scenes[this.currentScene].toolbox = new u.default(
                  this.scenes[this.currentScene].canvas
                )),
                  this.scenes[this.currentScene].toolbox.updateCanvas({
                    bbox: !1,
                    canvas: !0
                  }),
                  this.highlight(),
                  (this.playing = !1);
              }
            },
            {
              key: "update",
              value: function() {
                var t = this;
                if (this.playing) {
                  var e = new Date() - this.startTime;
                  if (e < this.scenes[this.currentScene].meta.duration)
                    this.scenes[this.currentScene].canvas.objects.forEach(
                      function(n) {
                        var i = void 0;
                        (i =
                          !n.tweening &&
                          n.tween &&
                          n.tween[100 * ~~(e / 100)]) &&
                          p.default.play(
                            n,
                            i.props,
                            i.duration,
                            i.easeFunc,
                            function() {
                              (t.scenes[t.currentScene].meta.tweening = !0),
                                (n.tweening = !0);
                            },
                            function() {
                              t.scenes[t.currentScene].canvas.render(),
                                (t.scenes[t.currentScene].meta.tweening = !1),
                                (n.tweening = !1);
                            }
                          );
                      }
                    ),
                      this.scenes[this.currentScene].meta.tweening &&
                        this.scenes[this.currentScene].canvas.render(),
                      window.requestAnimationFrame(function() {
                        t.update();
                      });
                  else {
                    if (!this.scenes[this.currentScene].meta.next)
                      return (
                        (this.scenes[this.currentScene].toolbox = new u.default(
                          this.scenes[this.currentScene].canvas
                        )),
                        this.btnPause(),
                        void (this.playing = !1)
                      );
                    (this.playing = !1),
                      this.playScene(this.scenes[this.currentScene].meta.next);
                  }
                }
              }
            },
            {
              key: "highlight",
              value: function() {
                var t = this;
                document
                  .querySelectorAll("ul.sceneList > li")
                  .forEach(function(e) {
                    e.getAttribute("scene") !== t.currentScene
                      ? e.classList.remove("selected")
                      : e.classList.add("selected");
                  });
              }
            },
            {
              key: "changeSeekBar",
              value: function() {
                $(this.seekBar)
                  .find("input[type=range]")
                  .val(this.currentScene);
              }
            },
            {
              key: "playScene",
              value: function(t) {
                this.playing ||
                  ((this.playing = !0),
                  this.btnPlay(),
                  (this.currentScene = t || this.currentScene),
                  this.changeSeekBar(),
                  (this.startTime = new Date()),
                  this.scenes[this.currentScene].toolbox &&
                    (this.scenes[this.currentScene].toolbox.destroy(),
                    delete this.scenes[this.currentScene].toolbox),
                  this.scenes[this.currentScene].audio &&
                    this.scenes[this.currentScene].audio.forEach(function(t) {
                      t.play();
                    }),
                  this.scenes[this.currentScene].canvas.render(),
                  this.highlight(),
                  this.update());
              }
            },
            {
              key: "start",
              value: function() {
                this.playScene(1),
                  this.background && this.background.canvas.render();
              }
            }
          ]),
          t
        );
      })();
    e.default = x;
  },
  function(t, e, n) {
    function i(t, e) {
      if (!(t instanceof e))
        throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", { value: !0 });
    var a = (function() {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, i.key, i);
          }
        }
        return function(e, n, i) {
          return n && t(e.prototype, n), i && t(e, i), e;
        };
      })(),
      s = (function() {
        function t(e) {
          var n = this;
          i(this, t),
            (this.type = "audio"),
            (this.audio = document.createElement("audio")),
            (this.url = e.url),
            (this.audio.src = this.url),
            (this.duration = e.duration || null),
            (this.audio.onloadedmetadata = function() {
              n.duration = n.audio.duration;
            });
        }
        return (
          a(t, [
            {
              key: "play",
              value: function() {
                this.audio.play();
              }
            },
            {
              key: "pause",
              value: function() {
                this.audio.pause();
              }
            },
            {
              key: "stop",
              value: function() {
                this.audio.pause(), (this.audio.currentTime = 0);
              }
            }
          ]),
          t
        );
      })();
    e.default = s;
  },
  function(t, e, n) {
    function i(t) {
      return t && t.__esModule ? t : { default: t };
    }
    function a(t, e) {
      if (!(t instanceof e))
        throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", { value: !0 });
    var s = (function() {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, i.key, i);
          }
        }
        return function(e, n, i) {
          return n && t(e.prototype, n), i && t(e, i), e;
        };
      })(),
      o = n(3),
      c = (i(o), n(1)),
      r = i(c),
      h = n(9),
      l = i(h),
      u = n(4),
      f = (i(u), n(0)),
      d = i(f),
      v = (function() {
        function t(e) {
          a(this, t),
            (this.tool = null),
            (this.edittool = null),
            (this.canvas = e),
            (this.dragging = !1),
            (this.instances = {}),
            (this.BBox = null),
            (this.KEY = {
              ALT: 18,
              SHIFT: 16,
              DEL: 46,
              UP: 38,
              DOWN: 40,
              LEFT: 37,
              RIGHT: 39,
              C: 67,
              D: 68,
              V: 86
            }),
            (this.objectIndex = null),
            this.clearBBox(this.canvas.interactContext),
            this.init();
        }
        return (
          s(t, [
            {
              key: "clearBBox",
              value: function(t) {
                t.clearRect(0, 0, t.canvas.width, t.canvas.height);
              }
            },
            {
              key: "renderBBox",
              value: function(t, e, n) {
                if (
                  (this.snaped &&
                    (Object.keys(this.snaped.x).length ||
                      Object.keys(this.snaped.y).length) &&
                    this.clearSnap(this.canvas.interactContext, this.snaped),
                  this.BBox)
                ) {
                  t.save(),
                    t.translate(this.BBox.x, this.BBox.y),
                    t.rotate(this.BBox.angle);
                  var i = this.BBox.width < 0 ? -5 : 5,
                    a = this.BBox.height < 0 ? -25 : 25,
                    s = -(this.BBox.anchorX + i),
                    o = -(this.BBox.anchorY + a),
                    c = this.BBox.width + 2 * i,
                    r = this.BBox.height + 2 * a;
                  t.clearRect(s, o, c, r), t.restore();
                }
                (this.BBox = n || e.getBBox()),
                  t.save(),
                  this.BBox &&
                    ((t.strokeStyle = this.BBox.stroke),
                    t.translate(this.BBox.x, this.BBox.y),
                    t.rotate(this.BBox.angle),
                    t.strokeRect(
                      -this.BBox.anchorX,
                      -this.BBox.anchorY,
                      this.BBox.width,
                      this.BBox.height
                    )),
                  this.dragging ||
                    this.scaling ||
                    this.rotating ||
                    ((t.fillStyle = "white"),
                    (t.strokeStyle = this.BBox.stroke),
                    t.beginPath(),
                    t.moveTo(
                      this.BBox.nodes.rotate.x,
                      this.BBox.nodes.rotate.y + 20
                    ),
                    t.lineTo(
                      this.BBox.nodes.rotate.x,
                      this.BBox.nodes.rotate.y
                    ),
                    t.stroke(),
                    (function(t, e) {
                      for (var n in e)
                        "anchor" === n
                          ? (t.beginPath(),
                            t.moveTo(e[n].x - 5, e[n].y - 5),
                            t.lineTo(e[n].x + 5, e[n].y + 5),
                            t.moveTo(e[n].x - 5, e[n].y + 5),
                            t.lineTo(e[n].x + 5, e[n].y - 5),
                            t.stroke())
                          : (t.beginPath(),
                            t.arc(e[n].x, e[n].y, 4, 0, 2 * Math.PI),
                            t.fill(),
                            t.stroke());
                    })(t, this.BBox.nodes)),
                  t.restore();
              }
            },
            {
              key: "nodeClicked",
              value: function(t, e) {
                for (var n in t) {
                  var i =
                      t[n].x * Math.cos(this.BBox.angle) -
                      t[n].y * Math.sin(this.BBox.angle) +
                      this.BBox.x,
                    a =
                      t[n].x * Math.sin(this.BBox.angle) +
                      t[n].y * Math.cos(this.BBox.angle) +
                      this.BBox.y;
                  if (
                    l.default.pointCollidesCircle(e, { x: i, y: a, radius: 4 })
                  )
                    return n;
                }
              }
            },
            {
              key: "inRange",
              value: function(t, e, n) {
                return t >= e && t <= n;
              }
            },
            {
              key: "applyTransform",
              value: function(t, e) {
                var n = this.canvas.objects[this.objectIndex],
                  i = this.BBox.angle,
                  a =
                    this.BBox.centerX * Math.cos(i) -
                    this.BBox.centerY * Math.sin(i) +
                    this.BBox.x,
                  s =
                    this.BBox.centerX * Math.sin(i) +
                    this.BBox.centerY * Math.cos(i) +
                    this.BBox.y;
                ("rectangle" !== n.type && "image" !== n.type) ||
                  (n.setWidth(Math.abs(this.BBox.width)),
                  n.setHeight(Math.abs(this.BBox.height)),
                  n.setX(a),
                  n.setY(s)),
                  "ellipse" === n.type &&
                    (n.setX(a),
                    n.setY(s),
                    n.setRadiusX(Math.abs(this.BBox.width) / 2),
                    n.setRadiusY(Math.abs(this.BBox.height) / 2)),
                  "text" === n.type &&
                    (n.setX(a),
                    n.setY(s),
                    n.setSize(Math.abs(this.BBox.height))),
                  this.BBox.height < 0 && n.setAngle(n.getAngle() + 180);
              }
            },
            {
              key: "scale",
              value: function(event, t, e, n, i) {
                var a = this.canvas.objects[this.objectIndex],
                  s = a.angle,
                  o = event.offsetX - a.x,
                  c = event.offsetY - a.y,
                  r = o * Math.cos(s) + c * Math.sin(s),
                  h = -o * Math.sin(s) + c * Math.cos(s),
                  l = 0,
                  u = 0,
                  f = 0,
                  v = 0,
                  g = 0,
                  y = 0;
                return (
                  "topLeft" === t
                    ? ((l = n ? Math.abs(r) : a.anchorX),
                      (u = n ? Math.abs(h) : a.anchorY),
                      (f = n ? 2 * l : l + r),
                      (v = n ? 2 * u : i ? (l + r) / this.whRatio : u + h),
                      (g = this.BBox.nodes[t].x + f / 2),
                      (y = this.BBox.nodes[t].y + v / 2))
                    : "bottomRight" === t
                      ? ((l = n ? Math.abs(r) : -r),
                        (u = n ? Math.abs(h) : i ? -r / this.whRatio : -h),
                        (f = n ? 2 * l : a.anchorX - r),
                        (v = n
                          ? 2 * u
                          : i
                            ? (a.anchorX - r) / this.whRatio
                            : a.anchorY - h),
                        (g = this.BBox.nodes[t].x - f / 2),
                        (y = this.BBox.nodes[t].y - v / 2))
                      : "topRight" === t
                        ? ((l = n ? Math.abs(r) : -r),
                          (u = n ? Math.abs(h) : a.anchorY),
                          (f = n ? 2 * l : a.anchorX - r),
                          (v = n
                            ? 2 * u
                            : i
                              ? (a.anchorX - r) / this.whRatio
                              : a.anchorY + h),
                          (g = this.BBox.nodes[t].x - f / 2),
                          (y = this.BBox.nodes[t].y + v / 2))
                        : "bottomLeft" === t
                          ? ((l = n ? Math.abs(r) : a.anchorX),
                            (u = n
                              ? Math.abs(h)
                              : i
                                ? -(a.anchorY - (a.anchorX + r) / this.whRatio)
                                : -h),
                            (f = n ? 2 * l : a.anchorX + r),
                            (v = n
                              ? 2 * u
                              : i
                                ? (a.anchorX + r) / this.whRatio
                                : a.anchorY - h),
                            (g = this.BBox.nodes[t].x + f / 2),
                            (y = this.BBox.nodes[t].y - v / 2))
                          : "topMiddle" === t
                            ? ((l = a.anchorX),
                              (u = n ? Math.abs(h) : a.anchorY),
                              (f = a.getWidth()),
                              (v = u + h),
                              (g = this.BBox.nodes[t].x),
                              (y = this.BBox.nodes[t].y + v / 2))
                            : "middleLeft" === t
                              ? ((l = n ? Math.abs(r) : a.anchorX),
                                (u = a.anchorY),
                                (f = l + r),
                                (v = a.getHeight()),
                                (g = this.BBox.nodes[t].x + f / 2),
                                (y = this.BBox.nodes[t].y))
                              : "middleRight" === t
                                ? ((l = -r),
                                  (u = a.anchorY),
                                  (f = n ? l - r : a.anchorX - r),
                                  (v = a.getHeight()),
                                  (g = this.BBox.nodes[t].x - f / 2),
                                  (y = this.BBox.nodes[t].y))
                                : "bottomMiddle" === t &&
                                  ((l = a.anchorX),
                                  (u = -h),
                                  (f = a.getWidth()),
                                  (v = n ? u - h : a.anchorY - h),
                                  (g = this.BBox.nodes[t].x),
                                  (y = this.BBox.nodes[t].y - v / 2)),
                  d.default.get({
                    type: "rectangle",
                    x: a.x,
                    y: a.y,
                    angle: s,
                    width: f,
                    height: v,
                    anchorX: l,
                    anchorY: u,
                    centerX: g,
                    centerY: y
                  })
                );
              }
            },
            {
              key: "startScale",
              value: function(t) {
                this.scaling = !0;
                var e = this.scale(
                  t,
                  this.BBox.nodes[this.nodeSelected].opposite,
                  this.nodeSelected,
                  this.neswScale,
                  this.uniformScale
                );
                this.updateCanvas({ bbox: !0, bboxConfig: e, canvas: !1 });
              }
            },
            {
              key: "stopScale",
              value: function(t) {
                this.scaling && this.applyTransform(),
                  (this.scaling = !1),
                  this.updateCanvas({ bbox: !0, canvas: !0 }),
                  $(this.canvas.canvasDOM).off("mousemove"),
                  $(this.canvas.canvasDOM).off("mouseup"),
                  $(this.canvas.canvasDOM).off("mouseleave");
              }
            },
            {
              key: "startRotate",
              value: function(t) {
                this.rotating = !0;
                var e = this.canvas.objects[this.objectIndex],
                  n = e.angle,
                  i = t.offsetX - e.x,
                  a = t.offsetY - e.y;
                (this.offsetX = i * Math.cos(n) + a * Math.sin(n)),
                  (this.offsetY = -i * Math.sin(n) + a * Math.cos(n));
                var s = Math.atan2(this.offsetY, this.offsetX),
                  o = s - this.startAngle,
                  c = d.default.get({
                    type: "rectangle",
                    x: e.x,
                    y: e.y,
                    angle: n + o,
                    width: e.width || 2 * e.radiusX,
                    height: e.height || 2 * e.radiusY,
                    anchorX: "ellipse" === e.type ? e.radiusX : e.anchorX,
                    anchorY: "ellipse" === e.type ? e.radiusY : e.anchorY
                  });
                this.updateCanvas({ bbox: !0, bboxConfig: c, canvas: !1 });
              }
            },
            {
              key: "stopRotate",
              value: function(t) {
                this.rotating = !1;
                var e = this.canvas.objects[this.objectIndex].angle,
                  n = t.offsetX - this.canvas.objects[this.objectIndex].x,
                  i = t.offsetY - this.canvas.objects[this.objectIndex].y;
                (this.offsetX = n * Math.cos(e) + i * Math.sin(e)),
                  (this.offsetY = -n * Math.sin(e) + i * Math.cos(e));
                var a = Math.atan2(this.offsetY, this.offsetX),
                  s = a - this.startAngle;
                (this.canvas.objects[this.objectIndex].angle += s),
                  this.updateCanvas({ bbox: !0, canvas: !0 }),
                  $(this.canvas.canvasDOM).off("mousemove"),
                  $(this.canvas.canvasDOM).off("mouseup"),
                  $(this.canvas.canvasDOM).off("mouseleave");
              }
            },
            {
              key: "mousedown",
              value: function(t) {
                var e = this.objectAtXY(t.offsetX, t.offsetY),
                  n = void 0;
                if (
                  (this.remove(this.edittool),
                  (n =
                    this.BBox &&
                    this.nodeClicked(this.BBox.nodes, {
                      x: t.offsetX,
                      y: t.offsetY
                    })))
                ) {
                  var i = this.canvas.objects[this.objectIndex].angle,
                    a = t.offsetX - this.canvas.objects[this.objectIndex].x,
                    s = t.offsetY - this.canvas.objects[this.objectIndex].y;
                  (this.offsetX = a * Math.cos(i) + s * Math.sin(i)),
                    (this.offsetY = -a * Math.sin(i) + s * Math.cos(i)),
                    "rotate" === n
                      ? ((this.startAngle = Math.atan2(
                          this.offsetY,
                          this.offsetX
                        )),
                        $(this.canvas.canvasDOM).on(
                          "mousemove",
                          this.startRotate.bind(this)
                        ),
                        $(this.canvas.canvasDOM).on(
                          "mouseup",
                          this.stopRotate.bind(this)
                        ),
                        $(this.canvas.canvasDOM).on(
                          "mouseleave",
                          this.stopRotate.bind(this)
                        ))
                      : "anchor" !== n &&
                        ((this.scaleAxis = this.BBox.nodes[n].scale),
                        (this.nodeSelected = n),
                        (this.whRatio = this.BBox.width / this.BBox.height),
                        $(this.canvas.canvasDOM).on(
                          "mousemove",
                          this.startScale.bind(this)
                        ),
                        $(this.canvas.canvasDOM).on(
                          "mouseup",
                          this.stopScale.bind(this)
                        ),
                        $(this.canvas.canvasDOM).on(
                          "mouseleave",
                          this.stopScale.bind(this)
                        )),
                    this.addEditTool(),
                    this.listSnapPoints();
                } else
                  e.length
                    ? ((this.objectIndex = e[0]),
                      this.addEditTool(),
                      this.updateCanvas({ bbox: !0, canvas: !1 }),
                      $(this.canvas.canvasDOM).on(
                        "mousemove",
                        this.startDrag.bind(this)
                      ),
                      $(this.canvas.canvasDOM).on(
                        "mouseup",
                        this.stopDrag.bind(this)
                      ),
                      $(this.canvas.canvasDOM).on(
                        "mouseleave",
                        this.stopDrag.bind(this)
                      ),
                      (this.offsetX =
                        t.offsetX - this.canvas.objects[this.objectIndex].x),
                      (this.offsetY =
                        t.offsetY - this.canvas.objects[this.objectIndex].y),
                      this.listSnapPoints())
                    : this.updateCanvas({ bbox: !1, canvas: !1 });
              }
            },
            {
              key: "listSnapPoints",
              value: function() {
                var t = this;
                (this.snapPoints = {
                  "-3": { x: this.canvas.width / 2, y: this.canvas.height / 2 },
                  "-2": { x: 0, y: 0 },
                  "-1": { x: this.canvas.width, y: this.canvas.height }
                }),
                  this.canvas.objects.forEach(function(e, n) {
                    t.snapPoints[n] = { x: e.getX(), y: e.getY() };
                  });
              }
            },
            {
              key: "startDrag",
              value: function(t) {
                (this.mouseX = t.offsetX), (this.mouseY = t.offsetY);
                var e = this.canvas.objects[this.objectIndex];
                if ((this.dragging = !0)) {
                  $(this.canvas.canvasDOM).addClass("cursor-drag"),
                    e.setX(this.mouseX - this.offsetX),
                    e.setY(this.mouseY - this.offsetY);
                  var n = e.getX(),
                    i = e.getY(),
                    a = { x: {}, y: {} };
                  for (var s in this.snapPoints)
                    if (s !== this.objectIndex) {
                      if (
                        n >= this.snapPoints[s].x - 5 &&
                        n <= this.snapPoints[s].x + 5
                      ) {
                        var o = this.snapPoints[s].x;
                        e.setX(o),
                          (a.x[o] = a.x[o] || {}),
                          (a.x[o].yMin = Math.min(
                            a.x[o].yMin || e.getY(),
                            this.snapPoints[s].y
                          )),
                          (a.x[o].yMax = Math.max(
                            a.x[o].yMax || e.getY(),
                            this.snapPoints[s].y
                          ));
                      }
                      if (
                        i >= this.snapPoints[s].y - 5 &&
                        i <= this.snapPoints[s].y + 5
                      ) {
                        var c = this.snapPoints[s].y;
                        e.setY(c),
                          (a.y[c] = a.y[c] || {}),
                          (a.y[c].xMin = Math.min(
                            a.y[c].xMin || e.getX(),
                            this.snapPoints[s].x
                          )),
                          (a.y[c].xMax = Math.max(
                            a.y[c].xMax || e.getX(),
                            this.snapPoints[s].x
                          ));
                      }
                    }
                  this.updateCanvas({
                    bbox: !0,
                    prop: ["x", "y"],
                    canvas: !1,
                    snap: a
                  });
                }
              }
            },
            {
              key: "stopDrag",
              value: function() {
                (this.dragging = !1),
                  this.updateCanvas({ bbox: !0, canvas: !0 }),
                  $(this.canvas.canvasDOM).removeClass("cursor-drag"),
                  $(this.canvas.canvasDOM).off("mousemove"),
                  $(this.canvas.canvasDOM).off("mouseup"),
                  $(this.canvas.canvasDOM).off("mouseleave");
              }
            },
            {
              key: "init",
              value: function() {
                this.addToolbox(),
                  this.addListener(),
                  $(this.canvas.canvasDOM).on(
                    "mousedown",
                    this.mousedown.bind(this)
                  );
              }
            },
            {
              key: "objectAtXY",
              value: function(t, e) {
                for (
                  var n = [], i = this.canvas.objects.length - 1;
                  i >= 0;
                  i--
                )
                  "circle" === this.canvas.objects[i].type &&
                    l.default.pointCollidesCircle(
                      { x: t, y: e },
                      this.canvas.objects[i]
                    ) &&
                    n.push(i),
                    ("rectangle" !== this.canvas.objects[i].type &&
                      "ellipse" !== this.canvas.objects[i].type &&
                      "image" !== this.canvas.objects[i].type &&
                      "text" !== this.canvas.objects[i].type) ||
                      (l.default.pointCollideBitmap(
                        { x: t, y: e },
                        this.canvas.objects[i]
                      ) &&
                        n.push(i));
                return n;
              }
            },
            {
              key: "changeOrder",
              value: function(t, e) {
                return r.default.move(this.canvas.objects, t, t + e);
              }
            },
            {
              key: "clone",
              value: function(t) {
                var e = this,
                  n = this.canvas.objects[t],
                  i = n.type;
                return new Promise(function(t, a) {
                  "rectangle" === i &&
                    t(
                      e.canvas.createObject({
                        type: i,
                        x: n.x + 10,
                        y: n.y + 10,
                        fill: Object.assign({}, n.fill),
                        stroke: n.stroke,
                        width: n.width,
                        height: n.height,
                        angle: n.angle
                      })
                    ),
                    "circle" === i &&
                      t(
                        e.canvas.createObject({
                          type: i,
                          x: n.x + 10,
                          y: n.y + 10,
                          fill: Object.assign({}, n.fill),
                          stroke: n.stroke,
                          radius: n.radius,
                          angle: n.angle
                        })
                      ),
                    "ellipse" === i &&
                      t(
                        e.canvas.createObject({
                          type: i,
                          x: n.x + 10,
                          y: n.y + 10,
                          fill: Object.assign({}, n.fill),
                          stroke: n.stroke,
                          radiusX: n.radiusX,
                          radiusY: n.radiusY,
                          angle: n.angle
                        })
                      ),
                    "image" === i &&
                      t(
                        e.canvas.createObject({
                          type: i,
                          x: n.x + 10,
                          y: n.y + 10,
                          url: n.url,
                          width: n.width,
                          height: n.height,
                          angle: n.angle
                        })
                      ),
                    "text" === i &&
                      t(
                        e.canvas.createObject({
                          type: i,
                          x: n.x + 10,
                          y: n.y + 10,
                          text: n.text,
                          size: n.size,
                          family: n.family,
                          fill: Object.assign({}, n.fill),
                          stroke: n.stroke,
                          angle: n.angle
                        })
                      );
                });
              }
            },
            {
              key: "deleteObj",
              value: function(t) {
                this.canvas.objects.splice(t, 1);
              }
            },
            {
              key: "destroy",
              value: function() {
                this.updateCanvas({ bbox: !1, canvas: !1 }),
                  $(this.canvas.canvasDOM).off(),
                  this.remove(this.edittool),
                  this.remove(this.tool);
              }
            },
            {
              key: "remove",
              value: function(t) {
                t &&
                  // (t.find(".fill").colorpicker("destroy"),
                  // t.find(".stroke").colorpicker("destroy"),
                  $(t).remove();
              }
            },
            {
              key: "updateCanvas",
              value: function(t) {
                var e = this;
                t.prop &&
                  t.prop.forEach(function(t) {
                    e.edittool
                      .find(".list-group.meta input[property=" + t + "]")
                      .val(e.canvas.objects[e.objectIndex][t]);
                  }),
                  t.bbox
                    ? this.renderBBox(
                        this.canvas.interactContext,
                        this.canvas.objects[this.objectIndex],
                        t.bboxConfig
                      )
                    : this.clearBBox(this.canvas.interactContext),
                  t.snap &&
                    this.renderSnap(this.canvas.interactContext, t.snap),
                  t.canvas && this.canvas.render();
              }
            },
            {
              key: "clearSnap",
              value: function(t, e) {
                t.save();
                for (var n in e.y) {
                  var i = e.y[n].xMax - e.y[n].xMin,
                    a = e.y[n].xMin,
                    s = n,
                    o = i < 0 ? -5 : 5;
                  t.clearRect(a - o, s - 5, i + 2 * o, 10);
                }
                for (var c in e.x) {
                  var r = e.x[c].yMax - e.x[c].yMin,
                    h = c,
                    l = e.x[c].yMin,
                    u = r < 0 ? -5 : 5;
                  t.clearRect(h - 5, l - u, 10, r + 2 * u);
                }
                t.restore();
              }
            },
            {
              key: "renderSnap",
              value: function(t, e) {
                (this.snaped = e),
                  t.save(),
                  (t.strokeStyle = "#6472EE"),
                  t.setLineDash([4, 2]),
                  (t.lineDashOffset = 2),
                  t.beginPath();
                for (var n in e.y)
                  t.moveTo(e.y[n].xMin, n), t.lineTo(e.y[n].xMax, n);
                for (var i in e.x)
                  t.moveTo(i, e.x[i].yMin), t.lineTo(i, e.x[i].yMax);
                t.stroke(), t.restore();
              }
            },
            {
              key: "addListener",
              value: function() {
                var t = this;
                $(this.canvas.canvasDOM).on("keyup", function(e) {
                  if (t.objectIndex >= 0)
                    switch ((e.preventDefault(), e.keyCode)) {
                      case t.KEY.ALT:
                        t.neswScale = !1;
                        break;
                      case t.KEY.SHIFT:
                        t.uniformScale = !1;
                    }
                }),
                  $(this.canvas.canvasDOM).on("keydown", function(e) {
                    if (t.objectIndex >= 0)
                      switch ((e.preventDefault(), e.keyCode)) {
                        case e.originalEvent.shiftKey && t.KEY.SHIFT:
                          t.uniformScale = !0;
                          break;
                        case e.originalEvent.altKey && t.KEY.ALT:
                          t.neswScale = !0;
                          break;
                        case t.KEY.DEL:
                          t.deleteObj(t.objectIndex),
                            t.remove(t.edittool),
                            t.updateCanvas({ bbox: !1, canvas: !0 });
                          break;
                        case e.originalEvent.shiftKey && t.KEY.LEFT:
                          (t.canvas.objects[t.objectIndex].x -= 20),
                            t.updateCanvas({
                              bbox: !0,
                              prop: ["x"],
                              canvas: !0
                            });
                          break;
                        case t.KEY.LEFT:
                          (t.canvas.objects[t.objectIndex].x -= 4),
                            t.updateCanvas({
                              bbox: !0,
                              prop: ["x"],
                              canvas: !0
                            });
                          break;
                        case e.originalEvent.shiftKey && t.KEY.RIGHT:
                          (t.canvas.objects[t.objectIndex].x += 20),
                            t.updateCanvas({
                              bbox: !0,
                              prop: ["x"],
                              canvas: !0
                            });
                          break;
                        case t.KEY.RIGHT:
                          (t.canvas.objects[t.objectIndex].x += 4),
                            t.updateCanvas({
                              bbox: !0,
                              prop: ["x"],
                              canvas: !0
                            });
                          break;
                        case e.originalEvent.shiftKey && t.KEY.UP:
                          (t.canvas.objects[t.objectIndex].y -= 20),
                            t.updateCanvas({
                              bbox: !0,
                              prop: ["y"],
                              canvas: !0
                            });
                          break;
                        case t.KEY.UP:
                          (t.canvas.objects[t.objectIndex].y -= 4),
                            t.updateCanvas({
                              bbox: !0,
                              prop: ["y"],
                              canvas: !0
                            });
                          break;
                        case e.originalEvent.shiftKey && t.KEY.DOWN:
                          (t.canvas.objects[t.objectIndex].y += 20),
                            t.updateCanvas({
                              bbox: !0,
                              prop: ["y"],
                              canvas: !0
                            });
                          break;
                        case t.KEY.DOWN:
                          (t.canvas.objects[t.objectIndex].y += 4),
                            t.updateCanvas({
                              bbox: !0,
                              prop: ["y"],
                              canvas: !0
                            });
                          break;
                        case (e.originalEvent.ctrlKey ||
                          e.originalEvent.metaKey) &&
                          t.KEY.D:
                          t.clone(t.objectIndex).then(function(e) {
                            (t.objectIndex = t.canvas.objects.length - 1),
                              t.updateCanvas({ bbox: !0, canvas: !0 });
                          });
                      }
                  }),
                  this.tool.find(".text").on("click", function() {
                    t.tool
                      .find("textarea")
                      .val()
                      .trim().length &&
                      t.tool.find("textarea") &&
                      t.canvas
                        .createObject({
                          type: "text",
                          text: t.tool.find("textarea").val(),
                          x: t.canvas.width / 2,
                          y: t.canvas.height / 2,
                          width: 100,
                          height: 100,
                          family: "sans-serif",
                          fill: { type: "solid", color: "#000000" },
                          stroke: null
                        })
                        .then(function() {
                          (t.objectIndex = t.canvas.objects.length - 1),
                            t.addEditTool(),
                            t.updateCanvas({ bbox: !0, canvas: !0 });
                        });
                  }),
                  this.tool.find(".rectangle").on("click", function() {
                    t.canvas
                      .createObject({
                        type: "rectangle",
                        x: t.canvas.width / 2,
                        y: t.canvas.height / 2,
                        width: 100,
                        height: 100,
                        fill: { type: "solid", color: "#cccccc" },
                        stroke: "#000000"
                      })
                      .then(function() {
                        (t.objectIndex = t.canvas.objects.length - 1),
                          t.addEditTool(),
                          t.updateCanvas({ bbox: !0, canvas: !0 });
                      });
                  }),
                  this.tool.find(".circle").on("click", function() {
                    t.canvas
                      .createObject({
                        type: "ellipse",
                        x: t.canvas.width / 2,
                        y: t.canvas.height / 2,
                        fill: { type: "solid", color: "#cccccc" },
                        stroke: "#000000"
                      })
                      .then(function() {
                        (t.objectIndex = t.canvas.objects.length - 1),
                          t.addEditTool(),
                          t.updateCanvas({ bbox: !0, canvas: !0 });
                      });
                  }),
                  this.tool.find(".image").on("click", function() {
                    t.tool.find("input[type=file]").trigger("click");
                  }),
                  this.tool.find("input.upload").change(function(e) {
                    var n = e.target.files;
                    if (n) {
                      var i = new FormData();
                      [].forEach.call(n, function(t) {
                        i.append("file[]", t);
                      }),
                        $.ajax({
                          url: "/upload",
                          method: "POST",
                          data: i,
                          contentType: !1,
                          processData: !1
                        })
                          .done(function(e) {
                            e.forEach(function(e) {
                              /(jpe?g|png|gif)$/i.test(e.mimetype) &&
                                t.canvas
                                  .createObject({
                                    type: "image",
                                    url: e.filename,
                                    x: t.canvas.width / 2,
                                    y: t.canvas.height / 2
                                  })
                                  .then(function() {
                                    (t.objectIndex =
                                      t.canvas.objects.length - 1),
                                      t.addEditTool(),
                                      t.updateCanvas({ bbox: !0, canvas: !0 });
                                  });
                            });
                          })
                          .fail(function(t) {
                            console.log(t);
                          });
                    }
                  });
              }
            },
            {
              key: "addToolbox",
              value: function() {
                this.tool = $(this.canvas.canvasDOM)
                  .after(
                    '\n                        <div class="toolbox left absolute" style="height : ' +
                      this.canvas.height +
                      'px;">\n                            <div class="tool rectangle">R</div>\n                            <div class="tool circle">C</div>\n                            <input type="file" class="upload" style="width: 0px; height: 0px; overflow: hidden;" />\n                        </div>\n                        '
                  )
                  .next();
              }
            },
            {
              key: "addEditTool",
              value: function() {
                var t = this;
                this.remove(this.edittool),
                  (this.edittool = $(this.canvas.canvasDOM)
                    .after(
                      '\n                        <div class="toolbox right absolute" style="height : ' +
                        this.canvas.height +
                        "px; margin-left : " +
                        $(this.canvas.canvasDOM).width() +
                        'px">\n                        <div class="tool rectangle layer up"><</div>\n                        <div class="tool rectangle layer down">></div>\n                      </div>\n                        '
                    )
                    .next());
                var e = this.canvas.objects[this.objectIndex];
                for (var n in e)
                  if (e.hasOwnProperty(n)) {
                    e[n];
                    if ("fill" === n || "stroke" === n) {
                      this.edittool.prepend(
                        '<div class="' +
                          n +
                          '">' +
                          n.charAt(0).toUpperCase() +
                          "</div>"
                      );
                      var i = e[
                        "get" + (n.charAt(0).toUpperCase() + n.slice(1))
                      ]();
                      this.edittool
                        .find("." + n)
                        .css({ "background-color": i });
                    }
                  }
                // this.edittool.find(".fill").colorpicker(),
                  // this.edittool.find(".stroke").colorpicker(),
                  this.edittool.find(".up").on("click", function(e) {
                    e.preventDefault(),
                      (t.objectIndex = t.changeOrder(t.objectIndex, 1)),
                      t.updateCanvas({ bbox: !0, canvas: !0 });
                  }),
                  this.edittool.find(".down").on("click", function(e) {
                    e.preventDefault(),
                      (t.objectIndex = t.changeOrder(t.objectIndex, -1)),
                      t.updateCanvas({ bbox: !0, canvas: !0 });
                  }),
                  this.edittool.find(".fill").on("changeColor", function(e) {
                    var n = e.color.toString("rgba");
                    t.canvas.objects[t.objectIndex].setFill(n),
                      t.edittool.find(".fill").css({ "background-color": n }),
                      t.updateCanvas({ bbox: !0, canvas: !0 });
                  }),
                  this.edittool.find(".stroke").on("changeColor", function(e) {
                    var n = e.color.toString("rgba");
                    t.canvas.objects[t.objectIndex].setStroke(n),
                      t.edittool.find(".stroke").css({ "background-color": n }),
                      t.updateCanvas({ bbox: !0, canvas: !0 });
                  });
              }
            }
          ]),
          t
        );
      })();
    e.default = v;
  },
  function(t, e, n) {
    function i(t) {
      return t && t.__esModule ? t : { default: t };
    }
    function a(t, e) {
      if (!(t instanceof e))
        throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", { value: !0 });
    var s = (function() {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, i.key, i);
          }
        }
        return function(e, n, i) {
          return n && t(e.prototype, n), i && t(e, i), e;
        };
      })(),
      o = n(15),
      c = (i(o), n(0)),
      r = i(c),
      h = (function() {
        function t(e) {
          a(this, t),
            (this.id = "circ_" + new Date().valueOf()),
            (this.type = "circle"),
            (this.x = e.x || 0),
            (this.y = e.y || 0),
            (this.scale = e.scale || 1),
            (this.radius = e.radius || 50),
            (this.startAngle = e.startAngle || 0),
            (this.endAngle = e.endAngle || 2 * Math.PI),
            (this.anchorX = e.x || 0),
            (this.anchorY = e.y || 0),
            (this.angle = e.angle || 0),
            (this.fill = e.fill || { type: "solid", color: null }),
            (this.stroke =
              null === e.stroke ? e.stroke : e.stroke || "#000000"),
            (this.angle = e.angle || 0),
            (this.tween = e.tween || null),
            (this.tweening = !1);
        }
        return (
          s(t, [
            {
              key: "getX",
              value: function() {
                return this.x;
              }
            },
            {
              key: "getY",
              value: function() {
                return this.y;
              }
            },
            {
              key: "getRadius",
              value: function() {
                return this.radius;
              }
            },
            {
              key: "getFill",
              value: function() {
                return this.fill.color;
              }
            },
            {
              key: "getStroke",
              value: function() {
                return this.stroke;
              }
            },
            {
              key: "getAngle",
              value: function() {
                return (180 * this.angle) / Math.PI;
              }
            },
            {
              key: "getScale",
              value: function() {
                return this.scale;
              }
            },
            {
              key: "setScale",
              value: function(t) {
                (this.scale = t), (this.radius *= t);
              }
            },
            {
              key: "setX",
              value: function(t) {
                this.x = t;
              }
            },
            {
              key: "setY",
              value: function(t) {
                this.y = t;
              }
            },
            {
              key: "setFill",
              value: function(t) {
                this.fill.color = t;
              }
            },
            {
              key: "setStroke",
              value: function(t) {
                this.stroke = t;
              }
            },
            {
              key: "setRadius",
              value: function(t) {
                this.radius = t;
              }
            },
            {
              key: "setAngle",
              value: function(t) {
                this.angle = (t * Math.PI) / 180;
              }
            },
            {
              key: "getBBox",
              value: function() {
                return r.default.get(this);
              }
            }
          ]),
          t
        );
      })();
    e.default = h;
  },
  function(t, e, n) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    var i = {
      pointCollidesRect: function(t, e, n) {
        return (
          n.strokeRect(e.x, e.y, e.width, e.height),
          t.x >= e.x &&
            t.x <= e.x + e.width &&
            t.y >= e.y &&
            t.y <= e.y + e.height
        );
      },
      pointCollidesCircle: function(t, e) {
        return i.distanceBetweenPoints(t, { x: e.x, y: e.y }) <= e.radius;
      },
      distanceBetweenPoints: function(t, e) {
        var n = t.x - e.x,
          i = t.y - e.y;
        return Math.sqrt(n * n + i * i);
      },
      pointCollideBitmap: function(t, e) {
        return e.getImageData(t).data[3];
      }
    };
    e.default = i;
  },
  function(t, e, n) {
    function i(t, e) {
      if (!(t instanceof e))
        throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", { value: !0 });
    var a = (function() {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, i.key, i);
          }
        }
        return function(e, n, i) {
          return n && t(e.prototype, n), i && t(e, i), e;
        };
      })(),
      s = (function() {
        function t() {
          i(this, t);
        }
        return (
          a(t, null, [
            {
              key: "export",
              value: function(t) {
                var e = this,
                  n = {
                    start: t.stage.start,
                    end: t.stage.end,
                    width: t.width,
                    height: t.height
                  };
                if (
                  (t.background &&
                    t.background.canvas.objects.length &&
                    ((n.background = { objects: [] }),
                    t.background.canvas.objects.forEach(function(t) {
                      n.background.objects.push(e.deserialize(t));
                    })),
                  Object.keys(t.scenes).length)
                ) {
                  n.foreground = { scene: {} };
                  for (var i in t.scenes)
                    !(function(i) {
                      (n.foreground.scene[i] = {
                        meta: Object.assign({}, t.scenes[i].meta),
                        objects: [],
                        audio: []
                      }),
                        t.scenes[i].canvas.objects.forEach(function(t) {
                          n.foreground.scene[i].objects.push(e.deserialize(t));
                        }),
                        t.scenes[i].audio &&
                          t.scenes[i].audio.forEach(function(t) {
                            n.foreground.scene[i].audio.push(e.deserialize(t));
                          });
                    })(i);
                }
                return n;
              }
            },
            {
              key: "deserialize",
              value: function(t) {
                return (
                  (t = Object.assign({}, t)),
                  "image" === t.type
                    ? {
                        type: "image",
                        url: t.url,
                        x: t.x,
                        y: t.y,
                        anchorX: t.anchorX,
                        anchorY: t.anchorY,
                        angle: t.angle,
                        width: t.width,
                        height: t.height,
                        animate: t.animate
                      }
                    : "text" === t.type
                      ? {
                          type: "text",
                          text: t.text,
                          x: t.x,
                          y: t.y,
                          style: t.style,
                          variant: t.variant,
                          weight: t.weight,
                          stretch: t.stretch,
                          size: t.size,
                          lineHeight: t.lineHeight,
                          family: t.family,
                          fill: t.fill,
                          stroke: t.stroke,
                          angle: t.angle,
                          animate: t.animate
                        }
                      : "audio" === t.type
                        ? { type: "audio", url: t.url, duration: t.duration }
                        : (delete t.id, t)
                );
              }
            }
          ]),
          t
        );
      })();
    e.default = s;
  },
  function(t, e, n) {
    function i(t) {
      return t && t.__esModule ? t : { default: t };
    }
    function a(t, e) {
      if (!(t instanceof e))
        throw new TypeError("Cannot call a class as a function");
    }
    function s(t, e) {
      if (!t)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return !e || ("object" !== typeof e && "function" !== typeof e) ? t : e;
    }
    function o(t, e) {
      if ("function" !== typeof e && null !== e)
        throw new TypeError(
          "Super expression must either be null or a function, not " + typeof e
        );
      (t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      })),
        e &&
          (Object.setPrototypeOf
            ? Object.setPrototypeOf(t, e)
            : (t.__proto__ = e));
    }
    Object.defineProperty(e, "__esModule", { value: !0 });
    var c = (function() {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, i.key, i);
          }
        }
        return function(e, n, i) {
          return n && t(e.prototype, n), i && t(e, i), e;
        };
      })(),
      r = n(2),
      h = i(r),
      l = n(0),
      u = i(l),
      f = (function(t) {
        function e(t, n) {
          a(this, e);
          var i = s(
            this,
            (e.__proto__ || Object.getPrototypeOf(e)).call(this, n)
          );
          return (
            (i.id = "circ_" + new Date().valueOf()),
            (i.type = "ellipse"),
            (i.x = t.x || 0),
            (i.y = t.y || 0),
            (i.scale = t.scale || 1),
            (i.radiusX = t.radiusX || 50),
            (i.radiusY = t.radiusY || 50),
            (i.startAngle = t.startAngle || 0),
            (i.endAngle = t.endAngle || 2 * Math.PI),
            (i.anchorX = i.radiusX || 0),
            (i.anchorY = i.radiusY || 0),
            (i.angle = t.angle || 0),
            (i.fill = t.fill || { type: "solid", color: null }),
            (i.stroke = null === t.stroke ? t.stroke : t.stroke || "#000000"),
            (i.angle = t.angle || 0),
            (i.tween = t.tween || null),
            (i.tweening = !1),
            i
          );
        }
        return (
          o(e, t),
          c(e, [
            {
              key: "getX",
              value: function() {
                return this.x;
              }
            },
            {
              key: "getY",
              value: function() {
                return this.y;
              }
            },
            {
              key: "getWidth",
              value: function() {
                return 2 * this.radiusX;
              }
            },
            {
              key: "getHeight",
              value: function() {
                return 2 * this.radiusY;
              }
            },
            {
              key: "getRadiusX",
              value: function() {
                return this.radiusX;
              }
            },
            {
              key: "getRadiusY",
              value: function() {
                return this.radiusY;
              }
            },
            {
              key: "getFill",
              value: function() {
                return this.fill.color;
              }
            },
            {
              key: "getStroke",
              value: function() {
                return this.stroke;
              }
            },
            {
              key: "getAngle",
              value: function() {
                return (180 * this.angle) / Math.PI;
              }
            },
            {
              key: "getScale",
              value: function() {
                return this.scale;
              }
            },
            {
              key: "setScale",
              value: function(t) {
                (this.scale = t), (this.radius *= t);
              }
            },
            {
              key: "setX",
              value: function(t) {
                this.x = t;
              }
            },
            {
              key: "setY",
              value: function(t) {
                this.y = t;
              }
            },
            {
              key: "setFill",
              value: function(t) {
                this.fill.color = t;
              }
            },
            {
              key: "setStroke",
              value: function(t) {
                this.stroke = t;
              }
            },
            {
              key: "setRadiusX",
              value: function(t) {
                this.radiusX = this.anchorX = t;
              }
            },
            {
              key: "setRadiusY",
              value: function(t) {
                this.radiusY = this.anchorY = t;
              }
            },
            {
              key: "setAngle",
              value: function(t) {
                this.angle = (t * Math.PI) / 180;
              }
            },
            {
              key: "getBBox",
              value: function() {
                return u.default.get(this);
              }
            },
            {
              key: "getImageData",
              value: function(t) {
                return (
                  this.context.clearRect(
                    0,
                    0,
                    this.canvas.width,
                    this.canvas.height
                  ),
                  this.context.save(),
                  this.context.translate(this.x, this.y),
                  null !== this.angle && this.context.rotate(this.angle),
                  this.context.beginPath(),
                  this.context.ellipse(
                    0,
                    0,
                    this.radiusX,
                    this.radiusY,
                    0,
                    this.startAngle,
                    this.endAngle
                  ),
                  null !== this.fill && this.context.fill(),
                  null !== this.stroke && this.context.stroke(),
                  this.context.restore(),
                  this.context.getImageData(t.x, t.y, 1, 1)
                );
              }
            }
          ]),
          e
        );
      })(h.default);
    e.default = f;
  },
  function(t, e, n) {
    function i(t) {
      return t && t.__esModule ? t : { default: t };
    }
    function a(t, e) {
      if (!(t instanceof e))
        throw new TypeError("Cannot call a class as a function");
    }
    function s(t, e) {
      if (!t)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return !e || ("object" !== typeof e && "function" !== typeof e) ? t : e;
    }
    function o(t, e) {
      if ("function" !== typeof e && null !== e)
        throw new TypeError(
          "Super expression must either be null or a function, not " + typeof e
        );
      (t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      })),
        e &&
          (Object.setPrototypeOf
            ? Object.setPrototypeOf(t, e)
            : (t.__proto__ = e));
    }
    Object.defineProperty(e, "__esModule", { value: !0 });
    var c = (function() {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, i.key, i);
          }
        }
        return function(e, n, i) {
          return n && t(e.prototype, n), i && t(e, i), e;
        };
      })(),
      r = n(2),
      h = i(r),
      l = n(0),
      u = i(l),
      f = (function(t) {
        function e(t, n) {
          a(this, e);
          var i = s(
            this,
            (e.__proto__ || Object.getPrototypeOf(e)).call(this, n)
          );
          return (
            (i.id = "img_" + new Date().valueOf()),
            (i.type = "image"),
            (i.x = t.x || 0),
            (i.y = t.y || 0),
            (i.scaleX = t.scaleX || 1),
            (i.scaleY = t.scaleY || 1),
            (i.url = t.url),
            (i.image = document.createElement("img")),
            (i.angle = null === t.angle ? null : t.angle || 0),
            (i.tween = t.tween || null),
            (i.tweening = !1),
            i
          );
        }
        return (
          o(e, t),
          c(e, [
            {
              key: "load",
              value: function(t, e) {
                var n = this;
                return new Promise(function(i, a) {
                  (n.image.src = n.url),
                    (n.image.onload = function() {
                      (n.width = n.image.width = t.width || n.image.width),
                        (n.height = n.image.height =
                          t.height || n.image.height),
                        (n.anchorX = n.width / 2),
                        (n.anchorY = n.height / 2),
                        (n.loaded = !0),
                        i(n);
                    });
                });
              }
            },
            {
              key: "getImageData",
              value: function(t) {
                return (
                  this.context.clearRect(
                    0,
                    0,
                    this.canvas.width,
                    this.canvas.height
                  ),
                  this.context.save(),
                  this.context.translate(this.x, this.y),
                  null !== this.angle && this.context.rotate(this.angle),
                  this.context.scale(this.scaleX, this.scaleY),
                  this.context.drawImage(
                    this.image,
                    -this.anchorX,
                    -this.anchorY,
                    this.width,
                    this.height
                  ),
                  this.context.restore(),
                  this.context.getImageData(t.x, t.y, 1, 1)
                );
              }
            },
            {
              key: "getX",
              value: function() {
                return this.x;
              }
            },
            {
              key: "getY",
              value: function() {
                return this.y;
              }
            },
            {
              key: "getWidth",
              value: function() {
                return this.width;
              }
            },
            {
              key: "getHeight",
              value: function() {
                return this.height;
              }
            },
            {
              key: "getAngle",
              value: function() {
                return (180 * this.angle) / Math.PI;
              }
            },
            {
              key: "getScaleX",
              value: function() {
                return this.scaleX;
              }
            },
            {
              key: "getScaleY",
              value: function() {
                return this.scaleY;
              }
            },
            {
              key: "setScaleX",
              value: function(t) {
                this.scaleX = t;
              }
            },
            {
              key: "setScaleY",
              value: function(t) {
                this.scaleY = t;
              }
            },
            {
              key: "setWidth",
              value: function(t) {
                (this.width = t), (this.anchorX = t / 2);
              }
            },
            {
              key: "setHeight",
              value: function(t) {
                (this.height = t), (this.anchorY = t / 2);
              }
            },
            {
              key: "setX",
              value: function(t) {
                this.x = t;
              }
            },
            {
              key: "setY",
              value: function(t) {
                this.y = t;
              }
            },
            {
              key: "setAngle",
              value: function(t) {
                this.angle = (t * Math.PI) / 180;
              }
            },
            {
              key: "getBBox",
              value: function() {
                return u.default.get(this);
              }
            }
          ]),
          e
        );
      })(h.default);
    e.default = f;
  },
  function(t, e, n) {
    function i(t, e) {
      if (!(t instanceof e))
        throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", { value: !0 });
    var a = (function() {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, i.key, i);
          }
        }
        return function(e, n, i) {
          return n && t(e.prototype, n), i && t(e, i), e;
        };
      })(),
      s = (function() {
        function t() {
          i(this, t);
        }
        return (
          a(t, null, [
            {
              key: "play",
              value: function(t, e, n, i, a, s) {
                var o = {},
                  c = {},
                  r = new Date();
                for (var h in e.from)
                  (o[h] = e.from[h]), (c[h] = e.to[h] - o[h]);
                this.ease(o, c, t, e.to, r, n, i, a, s);
              }
            },
            {
              key: "ease",
              value: function(t, e, n, i, a, s, o, c, r) {
                var h = this,
                  l = new Date() - a;
                if (l < s) {
                  for (var u in i)
                    n["set" + (u.charAt(0).toUpperCase() + u.slice(1))](
                      this[o](l / s, e[u], t[u])
                    );
                  c && c(),
                    window.requestAnimationFrame(function() {
                      h.ease(t, e, n, i, a, s, o, c, r);
                    });
                } else {
                  for (var f in i)
                    n["set" + (f.charAt(0).toUpperCase() + f.slice(1))](i[f]);
                  r && r();
                }
              }
            },
            {
              key: "quadEaseIn",
              value: function(t, e, n) {
                return e * t * t + n;
              }
            },
            {
              key: "quadEaseOut",
              value: function(t, e, n) {
                return e * t * (2 - t) + n;
              }
            },
            {
              key: "linear",
              value: function(t, e, n) {
                return e * t + n;
              }
            }
          ]),
          t
        );
      })();
    e.default = s;
  },
  function(t, e, n) {
    function i(t) {
      return t && t.__esModule ? t : { default: t };
    }
    function a(t, e) {
      if (!(t instanceof e))
        throw new TypeError("Cannot call a class as a function");
    }
    function s(t, e) {
      if (!t)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return !e || ("object" !== typeof e && "function" !== typeof e) ? t : e;
    }
    function o(t, e) {
      if ("function" !== typeof e && null !== e)
        throw new TypeError(
          "Super expression must either be null or a function, not " + typeof e
        );
      (t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      })),
        e &&
          (Object.setPrototypeOf
            ? Object.setPrototypeOf(t, e)
            : (t.__proto__ = e));
    }
    Object.defineProperty(e, "__esModule", { value: !0 });
    var c = (function() {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, i.key, i);
          }
        }
        return function(e, n, i) {
          return n && t(e.prototype, n), i && t(e, i), e;
        };
      })(),
      r = n(2),
      h = i(r),
      l = n(0),
      u = i(l),
      f = n(1),
      d = i(f),
      v = (function(t) {
        function e(t, n) {
          a(this, e);
          var i = s(
            this,
            (e.__proto__ || Object.getPrototypeOf(e)).call(this, n)
          );
          return (
            (i.type = "text"),
            (i.text = t.text),
            (i.x = t.x),
            (i.y = t.y),
            (i.scaleX = t.scaleX || 1),
            (i.scaleY = t.scaleY || 1),
            (i.textAlign = t.textAlign || "center"),
            (i.textBaseline = t.textBaseline || "middle"),
            (i.direction = t.direction || "ltr"),
            (i.style = t.style || "normal"),
            (i.variant = t.variant || "normal"),
            (i.weight = t.weight || "normal"),
            (i.stretch = d.default.isBrowser("safari")
              ? ""
              : t.stretch || "normal"),
            (i.size = t.size || 24),
            (i.unit = t.unit || "px"),
            (i.lineHeight = t.lineHeight || "1"),
            (i.family = t.family || "sans-serif"),
            i.context.save(),
            (i.context.font = i.font =
              i.style +
              " " +
              i.variant +
              " " +
              i.weight +
              " " +
              i.stretch +
              " " +
              (i.size + i.unit) +
              "/" +
              i.lineHeight +
              " " +
              i.family),
            (i.width = i.context.measureText(i.text).width),
            i.context.restore(),
            (i.height = i.size),
            (i.anchorX = i.width / 2),
            (i.anchorY = i.height / 2),
            (i.fill = t.fill || { type: "solid", color: null }),
            (i.stroke = null === t.stroke ? t.stroke : t.stroke || "#000000"),
            (i.angle = t.angle || 0),
            (i.tween = t.tween || null),
            (i.tweening = !1),
            i
          );
        }
        return (
          o(e, t),
          c(e, [
            {
              key: "getImageData",
              value: function(t) {
                return (
                  this.context.clearRect(
                    0,
                    0,
                    this.canvas.width,
                    this.canvas.height
                  ),
                  this.context.save(),
                  this.context.translate(this.x, this.y),
                  null !== this.angle && this.context.rotate(this.angle),
                  this.context.fillRect(
                    -this.anchorX,
                    -this.anchorY,
                    this.width,
                    this.height
                  ),
                  this.context.restore(),
                  this.context.getImageData(t.x, t.y, 1, 1)
                );
              }
            },
            {
              key: "getX",
              value: function() {
                return this.x;
              }
            },
            {
              key: "getY",
              value: function() {
                return this.y;
              }
            },
            {
              key: "getWidth",
              value: function() {
                return this.width;
              }
            },
            {
              key: "getHeight",
              value: function() {
                return this.height;
              }
            },
            {
              key: "getFill",
              value: function() {
                return this.fill.color;
              }
            },
            {
              key: "getStroke",
              value: function() {
                return this.stroke;
              }
            },
            {
              key: "getAngle",
              value: function() {
                return (180 * this.angle) / Math.PI;
              }
            },
            {
              key: "getScaleX",
              value: function() {
                return this.scaleX;
              }
            },
            {
              key: "getScaleY",
              value: function() {
                return this.scaleY;
              }
            },
            {
              key: "setScaleX",
              value: function(t) {
                this.scaleX = t;
              }
            },
            {
              key: "setScaleY",
              value: function(t) {
                this.scaleY = t;
              }
            },
            {
              key: "setSize",
              value: function(t) {
                (this.height = this.size = t),
                  this.context.save(),
                  (this.context.font = this.font =
                    this.style +
                    " " +
                    this.variant +
                    " " +
                    this.weight +
                    " " +
                    this.stretch +
                    " " +
                    (this.size + this.unit) +
                    "/" +
                    this.lineHeight +
                    " " +
                    this.family),
                  (this.width = this.context.measureText(this.text).width),
                  this.context.restore(),
                  (this.anchorX = this.width / 2),
                  (this.anchorY = this.height / 2);
              }
            },
            {
              key: "setX",
              value: function(t) {
                this.x = t;
              }
            },
            {
              key: "setY",
              value: function(t) {
                this.y = t;
              }
            },
            {
              key: "setWidth",
              value: function(t) {
                this.setSize((this.height / this.width) * t);
              }
            },
            {
              key: "setHeight",
              value: function(t) {
                this.setSize(t);
              }
            },
            {
              key: "setFill",
              value: function(t) {
                this.fill.color = t;
              }
            },
            {
              key: "setStroke",
              value: function(t) {
                this.stroke = t;
              }
            },
            {
              key: "setAngle",
              value: function(t) {
                this.angle = (t * Math.PI) / 180;
              }
            },
            {
              key: "getBBox",
              value: function() {
                return u.default.get(this);
              }
            }
          ]),
          e
        );
      })(h.default);
    e.default = v;
  },
  function(t, e, n) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    var i = {
      _x: 0,
      _y: 0,
      create: function(t) {
        var e = Object.create(this);
        return e.setX(t.x), e.setY(t.y), e;
      },
      setX: function(t) {
        this._x = t;
      },
      getX: function() {
        return this._x;
      },
      setY: function(t) {
        this._y = t;
      },
      getY: function() {
        return this._y;
      },
      setDirection: function(t) {
        var e = this.getMagnitude();
        (this._x = Math.cos(t) * e), (this._y = Math.sin(t) * e);
      },
      getDirection: function() {
        return Math.atan2(this._y, this._x);
      },
      setMagnitude: function(t) {
        var e = this.getDirection();
        (this._x = Math.cos(e) * t), (this._y = Math.sin(e) * t);
      },
      getMagnitude: function() {
        return Math.sqrt(this._x * this._x + this._y * this._y);
      },
      add: function(t) {
        return i.create({
          x: this.getX() + t.getX(),
          y: this.getY() + t.getY()
        });
      },
      subtract: function(t) {
        return i.create({
          x: this.getX() - t.getX(),
          y: this.getY() - t.getY()
        });
      },
      multiply: function(t) {
        return i.create({ x: this.getX() * t, y: this.getY() * t });
      },
      divide: function(t) {
        return i.create({ x: this.getX() / t, y: this.getY() / t });
      },
      addTo: function(t) {
        (this._x += t.getX()), (this._y += t.getY());
      },
      subtractFrom: function(t) {
        (this._x -= t.getX()), (this._y -= t.getY());
      },
      multiplyBy: function(t) {
        (this._x *= t), (this._y *= t);
      },
      divideBy: function(t) {
        (this._x /= t), (this._y /= t);
      }
    };
    e.default = i;
  },
  function(t, e, n) {
    function i(t, e) {
      if (!(t instanceof e))
        throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", { value: !0 });
    var a = (function() {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, i.key, i);
          }
        }
        return function(e, n, i) {
          return n && t(e.prototype, n), i && t(e, i), e;
        };
      })(),
      s = n(5),
      o = (function(t) {
        return t && t.__esModule ? t : { default: t };
      })(s),
      c = (function() {
        function t(e) {
          var n = this;
          i(this, t);
          var a = e.height + 100,
            s = ((e.height / a) * 100).toFixed(1),
            c = $(
              $.parseHTML(
                '<div class="tangible" style="width : ' +
                  e.width +
                  "px;height : " +
                  (e.height + 100) +
                  "px;background : linear-gradient( 0deg, transparent 0%, transparent " +
                  (100 - s) +
                  "%, white " +
                  (100 - s) +
                  '%, white 100%);margin: 0 auto;"></div>'
              )
            ).appendTo($(e.target));
          (this.stage = new o.default({
            data: e.data || null,
            width: e.width,
            height: e.height,
            target: c,
            path: e.path
          })),
            e.data &&
              (this.stage.ready = function() {
                n.stage.start();
              });
        }
        return (
          a(t, [
            {
              key: "destroy",
              value: function() {
                this.stage.destroy();
              }
            }
          ]),
          t
        );
      })();
    (Tangible = c), (e.default = c);
  }
]);

export default Tangible;



// WEBPACK FOOTER //
// ./src/Projects/tangible.js